import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import PerfectScrollbar from 'perfect-scrollbar';
import Swal from 'sweetalert2';
// import { AccionesComponent } from '../componentes/cierre-caja/acciones/acciones.component';
import { ControlsService } from '../shared/services/controls.service';
import { HttpMethodService } from './../shared/services/http-method.service';
import { AuthenticationService } from '../shared';
import { ChildrenItems, RouteInfo, ROUTES } from './data_menus';

declare const $: any;

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: RouteInfo[];
    ps: any;
    user: any = null;
    operationCenter: any = {};
    lastPermission: any = null;
    constructor(private methodService: HttpMethodService,
                private controlService: ControlsService,
                private authenticationService: AuthenticationService,
                public dialog: MatDialog) {

        this.controlService.updateOC.subscribe(async (item) => {
            this.user = JSON.parse(localStorage.getItem('currentUserCF')) || null;
        });
    }


    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    async ngOnInit() {
        
        // this.menuItems = ROUTES.filter(menuItem => menuItem);
        // let menu = JSON.parse(localStorage.getItem('menuCC'));
        this.lastPermission = localStorage.getItem('lastPermissionRefreshCF') || null;
        this.user = JSON.parse(localStorage.getItem('currentUserCF')) || null;
        await this.generarMenu();
        // this.operationCenter = operationCenters.find((a) => a.id === this.user.operation_center);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }
    }

    async generarMenu() {
        await this.verficarPermisos();
        await this.generarEstructuraMenu();
    }

    filtrarMenu(): any[] {
        let codigos = this.user.permisos;
        const menus = ROUTES.filter(option => codigos.includes(option.code) && option.type_collapsable.code === 1);
        return menus;
    }

    async verficarPermisos() {
        if (this.lastPermission) {
            const sixHoursInMilliseconds = 6 * 60 * 60 * 1000;
            const now = new Date().getTime();
            const lastPermissionTime = new Date(this.lastPermission).getTime();
    
            if (now - lastPermissionTime >= sixHoursInMilliseconds) {
                await this.serviceRefresh();
            }
        }else{
            await this.serviceRefresh();
        }
    }
    
    async serviceRefresh() {
        try{
            // this.user.permisos = [];
            const response = await this.methodService.get(`/api/usuario/refresh-permissions`);
            if (response.status === 'success') {
                this.user.permisos = response.data;
                localStorage.setItem('lastPermissionRefreshCF', new Date().toString());
                localStorage.setItem('currentUserCF', JSON.stringify(this.user));
            }
        } catch (error) {
            this.controlService.msgError(error.message || error.error.message);
        }
    }

    generarEstructuraMenu() {
        // -------------------------------------------------------------
        const codigos = this.user.permisos;
        // -------------------------------------------------------------
        let menusWork = [];
        if (this.user.rol) {
            menusWork = ROUTES.filter(option => option.code === 0);
            // Filtrar los elementos no autorizados y sus children directamente
            menusWork = menusWork.filter(element => {
                element.children = element.children.filter(child => 
                    !child.code || codigos.includes(child.code) // Incluir los que no tienen code o están permitidos
                );
                return element.children.length > 0; // Conservar solo los elementos con children válidos
            });
        }
        // -------------------------------------------------------------
        const menusSimple = ROUTES.filter(option => codigos.includes(option.code) && option.type_collapsable.code === 1);
        // -------------------------------------------------------------
        this.menuItems = menusWork.concat(menusSimple);
    }
    
    
    

    updatePS(): void  {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    async open() {
        await Swal.fire({
            title: 'Apertura de caja',
            html: `Desea hacer la apertura de la caja?`,
            icon: 'question',
            focusConfirm: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showCloseButton: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
          }).then(async(result) => {
            try {
              if (result.isConfirmed) {
                const response = await this.methodService.post(`/api/cashin-cashout/open`, {cash_value: 0});
                if (response.status === 'success') {
                  this.controlService.msgSucces(response.message);
                //   this.consultar();
                } else {
                  this.controlService.msgWarning(response.message);
                }
              }
            } catch (error) {
              this.controlService.msgError(error.message || error.error.message);
            }
          });
      
    }

    // openSave(item) {
    //     const modal = this.dialog.open(AccionesComponent, {
    //     hasBackdrop: true,
    //     height: 'auto',
    //     width: '1000px',
    //     closeOnNavigation: false,
    //     disableClose: true,
    //     data: {
    //       id: item._id
    //     }
    //     });
    
    //     modal.afterClosed().subscribe((items) => {
    //       if (items) {
    //         // this.consultar();
    //       }
    //     });
    //   }

      async actions() {
        //   try {
        //     const user = JSON.parse(localStorage.getItem('currentUserCF'));
        //     const response = await this.methodService.GET(`/api/cashin-cashout/by-operation-center/${user.operation_center}`);
        //     if (response.status === 'success') {
        //         if (response.data) {
        //             this.openSave(response.data);
        //         } else {
        //             this.open();
        //         }
        //     } 
        //   } catch (error) {
        //       console.log(error);
        //   }
      }

      cerrarSesion() {
        this.controlService.confirm('Cerrar Sesión', 'Desea cerrar la sesión?', 'question', (result) => {
            this.authenticationService.logout();
        }, 'Si', 'No');        
      }

}
